/**
 * @generated SignedSource<<63feb345eb83dcdcdf688882b9371cb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CategorizeStakeholderInputObject = {
  allocations: ReadonlyArray<CategorizationAllocationInputObject>;
  perspectiveId: string;
  stakeholderId: string;
};
export type CategorizationAllocationInputObject = {
  amountCents?: number | null | undefined;
  categoryId: string;
  ordinal?: number | null | undefined;
  sliceType?: string | null | undefined;
  weight?: number | null | undefined;
};
export type categorizationOverviewPage_CategorizeMutation$variables = {
  input: CategorizeStakeholderInputObject;
};
export type categorizationOverviewPage_CategorizeMutation$data = {
  readonly categorizeStakeholder: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type categorizationOverviewPage_CategorizeMutation = {
  response: categorizationOverviewPage_CategorizeMutation$data;
  variables: categorizationOverviewPage_CategorizeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "categorizationOverviewPage_CategorizeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CategorizeStakeholderMutationPayload",
        "kind": "LinkedField",
        "name": "categorizeStakeholder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "categorizationOverviewPage_CategorizeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CategorizeStakeholderMutationPayload",
        "kind": "LinkedField",
        "name": "categorizeStakeholder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e20cf64b07b46fa449dce874f2ccf6e2",
    "id": null,
    "metadata": {},
    "name": "categorizationOverviewPage_CategorizeMutation",
    "operationKind": "mutation",
    "text": "mutation categorizationOverviewPage_CategorizeMutation(\n  $input: CategorizeStakeholderInputObject!\n) {\n  categorizeStakeholder(input: $input) {\n    stakeholder {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "20d1966df685b455ba6dc0cb5f8186f3";

export default node;
